import {KeyValueModel, ModelBase} from "./ModelBase"

export class ClienteModel extends ModelBase {
    Descrizione: string
    Email: string
    Telefono: string
    PIva: string
    UfficioId: string
    Uffici: Array<KeyValueModel>

}
